import script from "./ProjectClientRoleDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectClientRoleDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectClientRoleDropdown.vue?vue&type=style&index=0&id=f4a971fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4a971fc"]])

export default __exports__